"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSharingApplyButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../components/SimpleButton"));
const AdaptableContext_1 = require("../AdaptableContext");
const TeamSharingApplyButton = (props) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const handleImport = React.useCallback(() => {
        adaptable.api.teamSharingApi.importSharedEntry(props.data);
    }, []);
    return (React.createElement(SimpleButton_1.default, { "data-name": "shared-entity-apply-button", onClick: handleImport, variant: "text", tooltip: "Import", icon: "import-export" }));
};
exports.TeamSharingApplyButton = TeamSharingApplyButton;
